'use client';

import { ReactNode } from 'react';

import { RadioTile, Row, Rows, Spacer, SpacerSize } from '@bytel/trilogy-react';

import { FundingType } from '@app-types/funding';

import { FundingDetailsBox } from '@components/funding-details-box';
import { YounitedIcon } from '@components/younited';

import { isYounited } from '@helpers/funding';

interface FundingRadioProps {
    funding: FundingType;
    handleSelectFunding: (funding: FundingType) => void;
    subtitle?: ReactNode;
    label: string;
    isChecked: boolean;
    showFundingDetails?: boolean;
    name: string;
}

export function FundingRadio({
    funding,
    handleSelectFunding,
    subtitle,
    label,
    isChecked,
    showFundingDetails = false,
    name,
}: Readonly<FundingRadioProps>) {
    return (
        <Row>
            <Rows gap={1}>
                <Row>
                    <RadioTile
                        name={name}
                        description={
                            <Rows gap={3}>
                                {isYounited(funding.type) && (
                                    <Row narrow>
                                        <Spacer size={SpacerSize.FOUR} />
                                        <YounitedIcon />
                                    </Row>
                                )}
                                <Row>{subtitle}</Row>
                            </Rows>
                        }
                        value={funding.label}
                        checked={isChecked}
                        onChange={() => handleSelectFunding(funding)}
                        id={`${showFundingDetails && 'funding-'}${funding.type}`}
                        label={label}
                        horizontal
                    />
                </Row>
                {showFundingDetails && isChecked && (
                    <Row>
                        <FundingDetailsBox funding={funding} />
                    </Row>
                )}
            </Rows>
        </Row>
    );
}
